import React, { Component } from 'react';
import PropTypes from 'prop-types';

import cable from '../cable';
import MessagesModal from './MessagesModal';

export default class MessagesBubble extends Component {
  static propTypes = {
    startOpen: PropTypes.bool.isRequired,
    connectionsFindApi: PropTypes.string.isRequired,
    unreadConnectionIds: PropTypes.array.isRequired,
    currentUser: PropTypes.any.isRequired,
    preselectedUser: PropTypes.string,
    preselectedConnection: PropTypes.string,
  };

  static defaultProps = {
    preselectedUser: null,
    preselectedConnection: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      open: this.props.startOpen,
      startConnection: null,
      unreadConnectionIds: this.props.unreadConnectionIds,
      selectedConnectionId: this.props.preselectedConnection,
    };
  }

  disableScroll() {
    $(document.body).addClass('u-overflow-hidden');
  }

  enableScroll() {
    $(document.body).removeClass('u-overflow-hidden');
  }

  handleOpen = () => {
    this.setState({ open: !this.state.open });
    this.disableScroll();
  };

  handleClose = () => {
    this.setState({ open: false, startConnection: null });
    this.enableScroll();
  };

  handleRead = (connectionId) => {
    Union.log('Decreasing unread counter by 1');
    const unreadConnectionIds = this.state.unreadConnectionIds;

    this.setState({
      unreadConnectionIds: unreadConnectionIds.filter((id) => id !== connectionId),
    });
  };

  subscribe() {
    Union.log('Bubble is subscribing to messages');

    this.subscription = cable.subscriptions.create(
      {
        channel: 'MessagesChannel',
        user_id: this.props.currentUser.id,
      },
      {
        received: (message) => {
          Union.log('Bubble received messages', message.connection_id);
          const unreadConnectionIds = this.state.unreadConnectionIds;

          if (unreadConnectionIds.indexOf(message.connection_id) === -1) {
            this.setState({
              unreadConnectionIds: unreadConnectionIds.concat(message.connection_id),
            });
          }
        },
      }
    );
  }

  unsubscribe() {
    if (this.subscription) {
      Union.log('Bubble is unsubscribing from messages');
      this.subscription.unsubscribe();
    }
  }

  selectConnection(recipient, open = true) {
    $.get(this.props.connectionsFindApi, { recipient }, (data) => {
      if (data.id) {
        Union.log('Picking an existing connection', data.id);
        this.setState({ selectedConnectionId: data.id, open });
      } else {
        Union.log('Starting a new connection');
        this.setState({ startConnection: data, open });
      }
    });
  }

  listenMessageButtonClick() {
    $(document).on('click', '[data-connection]', (e) => {
      Union.log('Clicked Message button');

      e.preventDefault();
      const $el = $(e.currentTarget);
      const recipientSlug = $el.data('connection');

      this.selectConnection(recipientSlug);
    });
  }

  unlistenMessageButtonClick() {
    $(document).off('click', '[data-connection]');
  }

  componentWillUnmount() {
    this.unsubscribe();
    this.enableScroll();
    this.unlistenMessageButtonClick();
  }

  componentDidMount() {
    this.subscribe();
    this.listenMessageButtonClick();

    if (this.props.preselectedUser) {
      this.selectConnection(this.props.preselectedUser, this.props.startOpen);
    }
  }

  render() {
    const { unreadConnectionIds, open, startConnection, selectedConnectionId } = this.state;

    return (
      <div>
        {open && (
          <MessagesModal
            onClose={this.handleClose}
            startConnection={startConnection}
            selectedConnectionId={selectedConnectionId}
            onRead={this.handleRead}
            {...this.props}
          />
        )}

        <a
          className={
            unreadConnectionIds.length > 0
              ? 'u-mr-3 md:u-mr-4 messages-bubble messages-bubble--hasNotification'
              : 'u-mr-3 md:u-mr-4 messages-bubble'
          }
          onClick={this.handleOpen}>
          <i className="Icon Icon-chat u-text-xl md:u-text-md u-text-grey-dark" />
          {unreadConnectionIds.length > 0 && !open && (
            <div className="badge-indicator">{unreadConnectionIds.length}</div>
          )}
        </a>
      </div>
    );
  }
}
